import { render } from "./NoteView.vue?vue&type=template&id=722bb90a"
import script from "./NoteView.vue?vue&type=script&lang=js"
export * from "./NoteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__